export const classTitle = 'bg-emerald-600 text-white px-3 py-2 rounded mb-2 text-center'

export const optionsProtocolo = [
  { label: 'Protocolo', value: 0 },
  { label: 'Ac.Number', value: 1 },
  { label: 'PacientID', value: 2 },
  { label: 'StudyUID', value: 3 },
  { label: 'ExamID', value: 4 }
]
export const optionsEtapa = [
  { value: 1, label: 'Ficha' },
  { value: 2, label: 'Fila' },
  { value: 3, label: 'E. Preparo' },
  { value: 4, label: 'S. Preparo' },
  { value: 5, label: 'E. Sala' },
  { value: 6, label: 'S. Sala' },
  { value: 7, label: 'Reconstrução' },
  { value: 8, label: 'Saída' }
]
export const optionsStatus = [
  { value: 1, label: 'Agendado' },
  { value: 2, label: 'Registrado' },
  { value: 3, label: 'Finalizado' },
  { value: 4, label: 'Cancelado' }
]
const hostname = window.location.hostname

export const valueProtocolo = hostname.includes('sedi2') ? 1 : 0
export const isLocalhost = hostname.includes('localhost')
export const isSedi2 = hostname.includes('sedi2')
export const isTelelaudo = hostname.includes('telelaudo')

export const endereco = [
  {
    $formkit: 'mask',
    name: 'ds_cep',
    label: 'Cep',
    mask: '#####-###',
    unmaskValue: true,
    outerClass: formClass(2)
  },
  {
    $formkit: 'text',
    name: 'ds_logradouro',
    label: 'Endereço',
    outerClass: formClass(6)
  },
  {
    $formkit: 'text',
    name: 'ds_numero',
    label: 'Número',
    outerClass: formClass(2)
  },
  {
    $formkit: 'text',
    name: 'ds_complemento',
    label: 'Complemento',
    outerClass: formClass(2)
  },
  {
    $formkit: 'text',
    name: 'ds_bairro',
    label: 'Bairro',
    outerClass: formClass(5)
  },
  {
    $formkit: 'text',
    name: 'ds_cidade',
    label: 'Cidade',
    outerClass: formClass(5)
  },
  {
    $formkit: 'text',
    name: 'ds_estado',
    label: 'UF',
    outerClass: formClass(2)
  }
]
